import React from 'react';

import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

import { useFindPublicCategories } from '../../hooks/public/find-categories.hook';
import { PUBLIC_PRODUCTS_APP_PATHS } from '../../../products/constants/public-products-paths.constants';

const useStyles = makeStyles(() => ({
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  link: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    height: 44,
    padding: '0 16px',
    color: '#fff',
    fontSize: '0.9rem',
    textDecoration: 'none',
  },
  linkActive: {
    fontWeight: 600,
  },
  skeleton: {
    flexShrink: 0,
    margin: '0 16px',
  },
}));

const CategoryNav: React.FC = () => {
  const classes = useStyles();
  const { loading, categories } = useFindPublicCategories();

  if (loading) {
    return (
      <nav className={classes.nav} aria-label="Catégories">
        {Array.from({ length: 5 }).map((skeleton, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Skeleton key={index} className={classes.skeleton} variant="text" width={80} height={24} />
        ))}
      </nav>
    );
  }

  return (
    <nav className={classes.nav} aria-label="Catégories">
      {categories.map((category) => (
        <NavLink
          key={category.id}
          to={PUBLIC_PRODUCTS_APP_PATHS.CATALOG_FOR(category.slug)}
          className={classes.link}
          activeClassName={classes.linkActive}
        >
          {category.name}
        </NavLink>
      ))}
    </nav>
  );
};

export default CategoryNav;
